import React from 'react';
import { Col, Row } from 'reactstrap';
import Button from '@mui/material/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWifi } from '@fortawesome/free-solid-svg-icons';

const PreviewCatalog = ({
  catalogData,
  buttonColor,
  fontColor,
  fontStyle,
}) => (

  <Row className="pb-4 border-bottom mb-4 mx-2" style={{ color: fontColor, fontFamily: fontStyle }}>
    <Col xs={3}>
      <img src={catalogData.previewImageSrc} alt="catalog" width="100%" />
    </Col>
    <Col xs={5}>
      <div>
        {catalogData.catTitle}
      </div>
      <div className="small mt-3">
        {catalogData.catTitle}
      </div>
      <div className="small">
        {catalogData.catLocation}
      </div>
      <div className="small mt-3">
        <FontAwesomeIcon icon={faWifi} className="mr-1" />
        Live Auction
      </div>
    </Col>
    <Col xs={4}>
      <div>
        {catalogData.catTimeLeft}
      </div>
      <div className="small">
        until live auction begins
      </div>
      <div className="mt-2">
        <Button variant="contained" size="small" style={{ backgroundColor: buttonColor, fontFamily: fontStyle }}>
          Bid Now
        </Button>
      </div>
      <div className="small mt-2">
        Register to bid
      </div>

    </Col>
  </Row>

);

export default PreviewCatalog;
